import { default as about_45us9kiw2OpfgnMeta } from "/opt/build/repo/pages/about-us.vue?macro=true";
import { default as contactsQ2Ks7vPefgMeta } from "/opt/build/repo/pages/contacts.vue?macro=true";
import { default as cookie_45policyZcRIsfqfIvMeta } from "/opt/build/repo/pages/cookie-policy.vue?macro=true";
import { default as donationsscvwskMSG2Meta } from "/opt/build/repo/pages/donations.vue?macro=true";
import { default as _91id_937F3TRyZyEyMeta } from "/opt/build/repo/pages/events/[id].vue?macro=true";
import { default as indexHR5Bie6djpMeta } from "/opt/build/repo/pages/events/index.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as privacy_45policyQXTlhFuZ55Meta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as educational_45support2TefsoOjL5Meta } from "/opt/build/repo/pages/services/educational-support.vue?macro=true";
import { default as indexi5MzpDfjPNMeta } from "/opt/build/repo/pages/services/index.vue?macro=true";
import { default as listening_45deskU5COtN42gjMeta } from "/opt/build/repo/pages/services/listening-desk.vue?macro=true";
import { default as psychological_45servicesb8ec9cfse9Meta } from "/opt/build/repo/pages/services/psychological-services.vue?macro=true";
import { default as training_45pathsyjVMeOmJ9BMeta } from "/opt/build/repo/pages/services/training-paths.vue?macro=true";
import { default as workshopsTLoBC2ZGZCMeta } from "/opt/build/repo/pages/services/workshops.vue?macro=true";
import { default as trasparenzavE8ygxVMBcMeta } from "/opt/build/repo/pages/trasparenza.vue?macro=true";
export default [
  {
    name: "about-us___it",
    path: "/about-us",
    component: () => import("/opt/build/repo/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/en/about-us",
    component: () => import("/opt/build/repo/pages/about-us.vue")
  },
  {
    name: "about-us___es",
    path: "/es/about-us",
    component: () => import("/opt/build/repo/pages/about-us.vue")
  },
  {
    name: "contacts___it",
    path: "/contacts",
    component: () => import("/opt/build/repo/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/opt/build/repo/pages/contacts.vue")
  },
  {
    name: "contacts___es",
    path: "/es/contacts",
    component: () => import("/opt/build/repo/pages/contacts.vue")
  },
  {
    name: "cookie-policy___it",
    path: "/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___es",
    path: "/es/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy.vue")
  },
  {
    name: "donations___it",
    path: "/donations",
    component: () => import("/opt/build/repo/pages/donations.vue")
  },
  {
    name: "donations___en",
    path: "/en/donations",
    component: () => import("/opt/build/repo/pages/donations.vue")
  },
  {
    name: "donations___es",
    path: "/es/donations",
    component: () => import("/opt/build/repo/pages/donations.vue")
  },
  {
    name: "events-id___it",
    path: "/events/:id()",
    component: () => import("/opt/build/repo/pages/events/[id].vue")
  },
  {
    name: "events-id___en",
    path: "/en/events/:id()",
    component: () => import("/opt/build/repo/pages/events/[id].vue")
  },
  {
    name: "events-id___es",
    path: "/es/events/:id()",
    component: () => import("/opt/build/repo/pages/events/[id].vue")
  },
  {
    name: "events___it",
    path: "/events",
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/en/events",
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "events___es",
    path: "/es/events",
    component: () => import("/opt/build/repo/pages/events/index.vue")
  },
  {
    name: "index___it",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "services-educational-support___it",
    path: "/services/educational-support",
    component: () => import("/opt/build/repo/pages/services/educational-support.vue")
  },
  {
    name: "services-educational-support___en",
    path: "/en/services/educational-support",
    component: () => import("/opt/build/repo/pages/services/educational-support.vue")
  },
  {
    name: "services-educational-support___es",
    path: "/es/services/educational-support",
    component: () => import("/opt/build/repo/pages/services/educational-support.vue")
  },
  {
    name: "services___it",
    path: "/services",
    component: () => import("/opt/build/repo/pages/services/index.vue")
  },
  {
    name: "services___en",
    path: "/en/services",
    component: () => import("/opt/build/repo/pages/services/index.vue")
  },
  {
    name: "services___es",
    path: "/es/services",
    component: () => import("/opt/build/repo/pages/services/index.vue")
  },
  {
    name: "services-listening-desk___it",
    path: "/services/listening-desk",
    component: () => import("/opt/build/repo/pages/services/listening-desk.vue")
  },
  {
    name: "services-listening-desk___en",
    path: "/en/services/listening-desk",
    component: () => import("/opt/build/repo/pages/services/listening-desk.vue")
  },
  {
    name: "services-listening-desk___es",
    path: "/es/services/listening-desk",
    component: () => import("/opt/build/repo/pages/services/listening-desk.vue")
  },
  {
    name: "services-psychological-services___it",
    path: "/services/psychological-services",
    component: () => import("/opt/build/repo/pages/services/psychological-services.vue")
  },
  {
    name: "services-psychological-services___en",
    path: "/en/services/psychological-services",
    component: () => import("/opt/build/repo/pages/services/psychological-services.vue")
  },
  {
    name: "services-psychological-services___es",
    path: "/es/services/psychological-services",
    component: () => import("/opt/build/repo/pages/services/psychological-services.vue")
  },
  {
    name: "services-training-paths___it",
    path: "/services/training-paths",
    component: () => import("/opt/build/repo/pages/services/training-paths.vue")
  },
  {
    name: "services-training-paths___en",
    path: "/en/services/training-paths",
    component: () => import("/opt/build/repo/pages/services/training-paths.vue")
  },
  {
    name: "services-training-paths___es",
    path: "/es/services/training-paths",
    component: () => import("/opt/build/repo/pages/services/training-paths.vue")
  },
  {
    name: "services-workshops___it",
    path: "/services/workshops",
    component: () => import("/opt/build/repo/pages/services/workshops.vue")
  },
  {
    name: "services-workshops___en",
    path: "/en/services/workshops",
    component: () => import("/opt/build/repo/pages/services/workshops.vue")
  },
  {
    name: "services-workshops___es",
    path: "/es/services/workshops",
    component: () => import("/opt/build/repo/pages/services/workshops.vue")
  },
  {
    name: "trasparenza___it",
    path: "/trasparenza",
    component: () => import("/opt/build/repo/pages/trasparenza.vue")
  },
  {
    name: "trasparenza___en",
    path: "/en/trasparenza",
    component: () => import("/opt/build/repo/pages/trasparenza.vue")
  },
  {
    name: "trasparenza___es",
    path: "/es/trasparenza",
    component: () => import("/opt/build/repo/pages/trasparenza.vue")
  }
]